import React, { useState, useRef, useContext } from 'react'
import { styled, faPaperPlane, lighten, getAccessibleTextColor } from '../../../../utilities'
import { IconButton, IntentsContext, withTheme } from '../../../../common';
import modules from './input.module.scss';

const StyledInput = styled.input`
  ${({ $backgroundColor, $color }) => ({
        backgroundColor: $backgroundColor || '',
        color: $color,
        ":::placeholder, ::-webkit-input-placeholder": {
            color: $color
        },
        ":-ms-input-placeholder": {
            color: $color
        }
    })}
`;

const StyledInputGroup = styled.div`
  ${({ $boxShadow, $backgroundColor, $color }) => ({
        backgroundColor: $backgroundColor || '',
        boxShadow: $boxShadow,
        color: $color
    })}
`;

const Input = React.forwardRef ((props = {}, inputRef) => {
    let { theme, onFocus, id } = props
    const { handleInput } = props
    const [input, setInput] = useState('')
    const { background, type } = theme
    const darkMode = type === 'dark'
    const backgroundColor = background ? lighten(background, darkMode ? .2 : .8) : ''
    const color = backgroundColor ? getAccessibleTextColor(backgroundColor) : ''
    const boxShadow = (!darkMode && props.boxShadow) ? props.boxShadow : 'none'
    const { Icons } = useContext(IntentsContext)

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            submitInput()
        }
    }
    const onChange = (event) => {
        setInput(event.target.value || '')
    }

    const submitInput = () => {
        handleInput(input)
        setInput('')
    }

    return <div className={modules.askInputGroup}>
        <StyledInputGroup $backgroundColor={backgroundColor} $color={color} $boxShadow={boxShadow} className={modules.textInputGroup} role="group">
            <StyledInput
                $backgroundColor={backgroundColor}
                $color={color}
                ref={inputRef}
                onFocus={onFocus}
                className={modules.textInput}
                onKeyUp={handleKeyPress}
                onChange={onChange}
                value={input || ''}
                type="text"
                placeholder="Type your questions here"
                aria-label="message to send"
                title="Message to send"
                autoComplete="off"
                id={id}
            />
            <IconButton CustomIcon={Icons?.send} variant={theme.sendAction ? 'sendAction' : 'primary'} className={modules.iconButton} type="submit" title="Send this message" aria-label="send" solid onClick={submitInput} icon={faPaperPlane} />
        </StyledInputGroup>
    </div>
})

Input.defaultProps = {
    id: 'CHAT-TEXT-INPUT',
    boxShadow: '0px 3px 4px -1px rgba(0,0,0,0.2), 1px 2px 8px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
}

export default withTheme(Input)